// Thin wrapper around the platform-invitation Cloud Function callables (Tasks 7
// and 8). Both are unauthenticated: getPlatformInvitationPreview never throws
// for a known invitation state, it returns { status } as a discriminator, so
// WelcomePage can render before sign-in resolves.

import { getFunctions } from 'firebase/functions';
import { appCallable } from '../utils/appCallable';
import { app } from '../firebase';

const functions = getFunctions(app, 'us-central1');
const callable = (name) => appCallable(functions, name);

export async function getPlatformInvitationPreview(token) {
    const result = await callable('getPlatformInvitationPreview')({ token });
    return result.data;
}

export async function acceptPlatformInvitation(token) {
    const result = await callable('acceptPlatformInvitation')({ token });
    return result.data;
}
